import {OpenInNew} from "@mui/icons-material";
import React from "react";
import {Box} from "@mui/system";


const wrapperStyle = {
    display: 'inline-block',
    position: 'relative',
    width: '20px',
    height: '20px',
    marginRight: '8px'
}

const iconStyle = {
    position: 'absolute',
    left: 0,
    top: 5,
    width: '100%',
    height: '100%'
}

function CCOOpenInNewTabIcon() {
    return (
        <Box sx={wrapperStyle}>
            <OpenInNew sx={iconStyle} className='openNew'/>
        </Box>
    )}

export default CCOOpenInNewTabIcon